import { render, staticRenderFns } from "./BelongedRedeemCode.vue?vue&type=template&id=a4c8d5ba&scoped=true&"
import script from "./BelongedRedeemCode.vue?vue&type=script&lang=js&"
export * from "./BelongedRedeemCode.vue?vue&type=script&lang=js&"
import style0 from "./BelongedRedeemCode.vue?vue&type=style&index=0&id=a4c8d5ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4c8d5ba",
  null
  
)

export default component.exports